module.exports = __webpack_public_path__ + "static/media/An Ice creme shop in a desert.17c86510.jpeg";